function gtag() {
  dataLayer.push(arguments);
}

function initGoogleAnalytics(googleAnalyticsId) {
  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];

  // Define gtag function
  function gtag() {
    window.dataLayer.push(arguments);
  }

  function gtagEcommerce (data) {
    window.dataLayer.push(data);
  }
  
  window.gtag = gtag;
  window.gtagEcommerce = gtagEcommerce;

  // Load Google Analytics script externally
  var gaScript = document.createElement("script");
  gaScript.async = true;
  gaScript.src =
    "https://www.googletagmanager.com/gtag/js?id=" +
    encodeURIComponent(googleAnalyticsId);

  gaScript.onload = function () {
    gtag("js", new Date());
    gtag("config", googleAnalyticsId, { send_page_view: false });
  };

  document.head.appendChild(gaScript);
}
